module.exports = __webpack_public_path__ + "img/role_joy.a71b3f55.png";